import * as dayjs from 'dayjs';

export const LOCALIZED_DATE_FORMAT = 'LLLL';
export const LOCALIZED_TIME_FORMAT = 'LT';
export const YEAR_FORMAT = 'YYYY';

class DateService {
	public static formatLocalizedDate(date: string | Date): string {
		const year = dayjs(date).format(YEAR_FORMAT);
		const localizedFormattedDate = dayjs(date).format(LOCALIZED_DATE_FORMAT);

		// localized format without year
		return localizedFormattedDate.replace(` ${year}`, '');
	}

	public static formatTime(date: string | Date): string {
		return dayjs(date).format(LOCALIZED_TIME_FORMAT);
	}
}

export default DateService;
